import React from 'react';
import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { TextPairing } from '@components/TextPairing';
import { Columns, Column } from '@components/Columns';
import { CTALink } from '@components/CTALink';
import { themeColor } from '@utils/styledTheme.util';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { JoykitIcon, JoykitIconProps } from '@components/JoykitIcon';

export const StyledIconColumn = styled(Columns.Column)`
  ${themeMediaQuery('below_sm')} {
    width: 25%;
    display: inline-flex;
  }
  ${themeMediaQuery('sm')} {
    width: 12.5%;
    display: block;
  }
`;

const StyledIcon: React.FC<Omit<JoykitIconProps, 'color'>> = ({ ...iconProps }) => {
  return <JoykitIcon size={64} color="neutra4" {...iconProps} />;
};

export const IconsWrapper = styled(Flex)`
  width: 100%;
`;

export const StyledHoveIcon = styled(StyledIcon)`
  opacity: 0;
  width: 84px;
  height: 88px;
  position: absolute;
  & svg {
    margin-top: -8px;
    transition: opacity 250ms cubic-bezier(0.23, 1, 0.32, 1) 200ms, transform 250ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  }
`;

export const StyledThumbnailIcon = styled(StyledIcon)`
  transition: transform 250ms cubic-bezier(0.23, 1, 0.32, 1) 100ms;
  transform: rotate(0deg);
`;

export const StyledIconLink = styled(CTALink)`
  display: block;
  width: 100%;
  &:hover ${StyledThumbnailIcon} {
    transform: rotate(-15deg);
  }
  &:hover ${StyledHoveIcon} {
    opacity: 1;
  }
  &:hover .department-text {
    color: ${themeColor('actionPurple2')};
  }
  &:hover .department-text {
    color: ${themeColor('actionPurple2')};
  }
`;

export const StyledSectionWrapper = styled(Box)`
  text-align: center;
`;

export const StyledBox = styled(Flex)`
  margin: auto;
  flex-direction: column;
  width: 100%;
`;

export const BlogCenterTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 280px;
  }
  .text-pairing-body {
    max-width: 595px;
  }
  ${themeMediaQuery('sm')} {
    .text-pairing-title {
      max-width: 400px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 580px;
    }
  }
`;

export const StyledDepartmentColumn = styled(Columns)``;

export const StyledDesktopDepartmentColumn = styled(StyledDepartmentColumn)`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const FeatureText = styled(Text)`
  width: 100%;
  &::before,
  &::after {
    background-color: #807566;
    content: '';
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    opacity: 0.1;
    ${themeMediaQuery('below_sm')} {
      width: 35.6%;
    }
    ${themeMediaQuery('sm')} {
      width: 39.7%;
    }
    ${themeMediaQuery('lg')} {
      width: 43.7%;
    }
  }
  &::before {
    right: ${themeSpace(5)};
    margin-left: -50%;
  }
  &::after {
    left: ${themeSpace(5)};
    margin-right: -50%;
  }
`;

export const StyledBorderColumn = styled(Column)`
  border-bottom: 1px solid rgb(128, 117, 102, 0.1);
`;

export const StyledColumn = styled(Columns)``;

export const StyledCatalogColumn = styled(Columns.Column)<{
  context: number;
}>`
  ${themeMediaQuery('below_sm')} {
    width: 50%;
    display: inline-flex;
  }
  ${themeMediaQuery('sm')} {
    width: 20%;
    display: ${props => (props.context < 5 ? 'inline-flex' : 'none')};
  }
`;

export const StyledCatalogLink = styled(CTALink)`
  & span {
    display: block;
    white-space: initial;
  }
`;

export const ProductTitleText = styled(Text)`
  font-size: 13px;
  line-height: 18px;
  letter-spacing: -0.002em;
  color: rgb(113, 113, 113);
  display: inline-flex;
`;

export const ProductBodyText = styled(Text)`
  font-size: 15px;
  letter-spacing: -0.001em;
  line-height: 22px;
  width: 156px;
`;
